import Handels from '@/utils/handels.js';

// 初始化 handels 类的实例
let messages = {};

const locales =
    import.meta.glob(['./modules/*.json', './modules/**/*.json'], { eager: true })

for (const path in locales) {
    const [filePath, locale, fileName] = path.match(/\/([^/]+)\/([^/]+)\.json$/)

    let localesName = filePath.replace("\/modules\/", "").replace(".json", "")

    //window.$Log("filePath.meta 22==", localesName, locale, fileName)
    messages[localesName] = locales[path].default || locales[path]
}

//console.log("messages4.meta==", messages)
const obj = []
const entry = Object.entries(messages)
for (const [key, value] of entry) {
    //console.log("meta.key4==", key, value)
    if (key.indexOf(Handels.CurrentLangeuage()) > -1) {
        obj.push(value)
    }
}
messages = {}
messages[Handels.CurrentLangeuage()] = Object.assign({}, ...obj)
    //console.log("newObj.meta==", messages)
export default messages